import React, { useState, useMemo } from "react";
import Typography from "@material-ui/core/Typography";
import { TestReportPreview } from "../../components/Administration/TestReportPreview/TestReportPreview";
import { TestReportPicker } from "../../components/Administration/TestReportPreview/TestReportPicker";

/**
 * Display test reports
 */
export const TestReportsPage = () => {
	const [selectedReport, setSelectedReport] = useState<string | null>(null);
	return (
		<div>
			<Typography style={{ marginBottom: 24 }} variant="h4" data-testid="test-reports-page">
				Test Reports
			</Typography>
			<div style={{ display: "flex" }}>
				<div style={{ marginRight: 24, width: 320 }}>
					{useMemo(
						() => (
							<TestReportPicker onReportSelect={setSelectedReport} />
						),
						[setSelectedReport],
					)}
				</div>
				<div style={{ width: "100%" }}>{selectedReport && <TestReportPreview report={selectedReport} />}</div>
			</div>
		</div>
	);
};
